import React from 'react';
import {FormGroup, InputGroup, Switch} from '@blueprintjs/core';

interface TextInputProps {
  value: string;
  disabled: boolean;
  onChange: (value: any) => void;
}

export const TextInput = ({value, disabled, onChange}: TextInputProps) => {
  const onValueChange = (event: any) => onChange(event.target.value);

  return (
    <FormGroup>
      <InputGroup
        className="text-input"
        defaultValue={value}
        disabled={disabled}
        type="text"
        onChange={onValueChange}
      />
    </FormGroup>
  )
};
